/**
 * Created by jonas on 2020-11-02.
 */
import {MentalNormalSymbol} from "./MentalNormalSymbol";
import {MentalSymbolStates} from "../MentalSymbol";
import {Mental} from "../../Mental";

export class StackedWild extends MentalNormalSymbol {
    private _xNudgeSpine: PIXI.spine.Spine;

    constructor(name: string) {
        super(name);

        this.clear();
    }

    public clear(): void {
        if (this._xNudgeSpine) {
            this._xNudgeSpine.state.clearTracks();
        }

        super.clear();
    }

    public setState(state: MentalSymbolStates): void {
        super.setState(state);

        switch (state) {
            case MentalSymbolStates.NONE:
                this.createXNudgeSpine();
                break;
        }
    }

    public doTint(value: number) {
        this._xNudgeSpine.tint = value;
    }

    protected onPosition(): void {
        this.layerSet.position.set(this.position.x, this.position.y);
    }

    private createXNudgeSpine(): void {
        this._xNudgeSpine = new PIXI.spine.Spine(Mental.assetLoader.getSpineAsset("wildNudge"));
        this._xNudgeSpine.position.set(144 / 2, 198 * 1.25);

        this._symbolLayer.addChild(this._xNudgeSpine);
    }
}